import React, { JSX } from 'react'
import {
  ArrowsRightLeftIcon,
  ArrowTrendingUpIcon,
  ChartBarIcon,
  GiftIcon,
  PlayCircleIcon,
  RectangleGroupIcon,
  SignalIcon,
  TrophyIcon,
  UserGroupIcon
} from '@heroicons/react/24/outline'

const COMING_SOON_PITCH: Array<{ icon: typeof SignalIcon, text: string }> = [
  { icon: ChartBarIcon, text: 'Live polls your viewers vote on straight from chat' },
  { icon: ArrowsRightLeftIcon, text: 'Tug of wars: two sides battle it out, and chat picks the winner' },
  { icon: TrophyIcon, text: 'Scoreboards with live score controls during the stream' },
  { icon: RectangleGroupIcon, text: 'Composite desktop and mobile overlays: arrange everything in scenes and take them live' },
  { icon: UserGroupIcon, text: 'Team access: invite editors and co-hosts to run it with you' },
  { icon: GiftIcon, text: 'Giveaways your chat enters live, with winners drawn on stream' },
  { icon: ArrowTrendingUpIcon, text: 'Higher limits on overlays, emote walls and storage' }
]

const ComingSoonChip = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <span className='shrink-0 rounded-full bg-dm-bg-accent/50 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-dm-text-accent ring-1 ring-inset ring-white/10'>
    {children}
  </span>
)

export const StreamsComingSoonPage = (): JSX.Element => (
  <main
    className='flex flex-1 flex-col items-center overflow-y-auto px-8 py-16'
    data-testid='streams-coming-soon'
  >
    <div className='flex w-full max-w-2xl flex-col items-center gap-5 text-center'>
      <div className='flex h-16 w-16 items-center justify-center rounded-full bg-brand/10 text-brand ring-1 ring-brand/20'>
        <SignalIcon className='size-8' aria-hidden='true' />
      </div>
      <ComingSoonChip>Coming soon</ComingSoonChip>
      <h1 className='text-xl font-semibold text-dm-text-primary'>
        Streams are coming to FlightDeck
      </h1>
      <p className='text-sm text-dm-text-secondary'>
        FlightDeck Pro and Creator are coming soon. A stream ties your
        interactive content together: audience-driven polls, tug of wars
        and scoreboards, arranged in scenes on one composite overlay your
        viewers watch live.
      </p>
      <ul className='w-full space-y-2 text-left'>
        {COMING_SOON_PITCH.map(({ icon: Icon, text }) => (
          <li
            key={text}
            className='flex items-start gap-3 rounded-lg border border-white/5 bg-dm-bg-secondary px-4 py-3'
          >
            <Icon className='mt-0.5 size-5 shrink-0 text-brand' aria-hidden='true' />
            <span className='text-sm text-dm-text-secondary'>{text}</span>
          </li>
        ))}
      </ul>
      <div className='flex aspect-video w-full items-center justify-center rounded-xl border border-white/5 bg-dm-bg-secondary'>
        <PlayCircleIcon className='size-14 text-dm-text-accent' aria-hidden='true' />
      </div>
      <p className='text-[11px] text-dm-text-accent'>
        Your chat overlays and emote walls stay free, find them under
        Quick Overlays.
      </p>
    </div>
  </main>
)
